import {IEventData} from "../../types/types";
import {backendParser} from "./backendParser";

export const parseURL = (url: string, bias: {lat: number | null, long: number | null}): Promise<IEventData[]> => {
    return backendParser(url, bias).catch((e) => {
        console.log("CAUGHT ERROR ", e);
        throw e;
    })
};
